import { AnyAction } from "redux";
import { cloneDeep } from "lodash";
import { FETCH_EXAMS } from "../actions/exams";

interface Iexams {
  exames: any;
}

const initialState: Iexams = {
  exames: null,
};

export const ExamesReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case FETCH_EXAMS: {
      return {
        ...cloneDeep(state),
        exames: action.exames,
      };
    }
    default: {
      return state;
    }
  }
};
